import {
  child,
  get,
  push,
  ref,
  serverTimestamp,
  update,
} from "firebase/database";
import moment from "moment";
import "moment/locale/ko";
import CryptoJS from "crypto-js";
import { database } from "../../components/fBase";
import { isBeta } from "../../components/webConfig";
import fword from "../../datafiles/fword_data.json";

// 단건 메세지 보내기.
export const sendMsg = async (
  partyId: number,
  hostUid: number,
  guestUid: number,
  fromUid: number,
  toUid: number,
  msg: string,
  _time: any,
  isRead: boolean
) => {
  const dbRef = ref(database, isBeta ? "Beta/Messages" : "Live/Messages");
  const messageRef = child(
    dbRef,
    String(partyId) + "@" + String(hostUid) + "@" + String(guestUid)
  );

  try {
    return await push(messageRef, {
      message: {
        sender: fromUid,
        receiver: toUid,
        msg: msg,
        time: serverTimestamp(),
        isRead: isRead,
      },
    });
  } catch (error) {
    return error;
  }
};

// 파티방 별 마지막 메세지 저장하기
export const saveEachRoomLastMsg = async (
  partyId: number,
  guestUid: number,
  msgValue: string,
  time: any,
  fromUid: number,
  toUid: number,
  isRead: boolean
) => {
  console.log(partyId, guestUid, msgValue, time, fromUid, toUid, isRead);
  const dbRef = ref(
    database,
    isBeta ? "Beta/PartyChatRooms" : "Live/PartyChatRooms"
  );
  const chatRoomsRef = child(
    dbRef,
    "ROOM@" + String(partyId) + "/WITH@" + String(guestUid)
  );

  const chatRoomsLoggedInRef = child(
    dbRef,
    "ROOM@" + String(partyId) + "/WITH@" + String(guestUid) + "/loggedIn"
  );

  try {
    update(chatRoomsRef, {
      message: {
        msg: msgValue,
        time: serverTimestamp(),
        from: fromUid,
        to: toUid,
        isRead: isRead,
      },
    });

    if (fromUid === guestUid) {
      return await update(chatRoomsLoggedInRef, {
        Guest_lastTime: serverTimestamp(),
      });
    } else {
      return await update(chatRoomsLoggedInRef, {
        Host_lastTime: serverTimestamp(),
      });
    }
  } catch (error) {
    return error;
  }
};

// 하루 보낸 메세지 개수 리턴
export const getLimitSentCntADay = async (user: {
  loginSuccess: { uid: number };
}) => {
  const uid = user?.loginSuccess?.uid ?? 0;
  let todayCnt = 0;

  const dbRef = ref(database, isBeta ? "Beta/UserSentCnt" : "Live/UserSentCnt");
  const userSentCntRef = child(dbRef, "@" + String(uid));

  try {
    return await get(userSentCntRef).then((snapshot) => {
      console.log(snapshot.val());
      if (snapshot.val() !== null) {
        if (snapshot.val().day === moment().format("YYYY-MM-DD")) {
          todayCnt = snapshot.val()?.sentCnt ?? 1;
        } else {
          todayCnt = 0;
        }
      } else {
        todayCnt = 0;
      }

      console.log(todayCnt);
      return todayCnt;
    });
  } catch (error) {
    return error;
  }
};

// 하루 보낸 메세지 개수 저장
export const saveLimitSentCntADay = async (
  user: { loginSuccess: { uid: number } },
  sentCnt: number
) => {
  const uid = user?.loginSuccess?.uid ?? 0;
  console.log(sentCnt);

  const dbRef = ref(database, isBeta ? "Beta/UserSentCnt" : "Live/UserSentCnt");
  const userSentCntRef = child(dbRef, "@" + String(uid));

  try {
    return await update(userSentCntRef, {
      day: moment().format("YYYY-MM-DD"),
      sentCnt,
    });
  } catch (error) {
    return error;
  }
};

// 방에 입장한다.
export const EnterRoom = async (
  partyId: number,
  guestUid: number,
  enterUid: number
) => {
  console.log(partyId, guestUid, enterUid);
  const dbRef = ref(
    database,
    isBeta ? "Beta/PartyChatRooms" : "Live/PartyChatRooms"
  );
  const chatRoomsRef = child(
    dbRef,
    "ROOM@" + String(partyId) + "/WITH@" + String(guestUid) + "/loggedIn"
  );
  const chatRoomsMessageRef = child(
    dbRef,
    "ROOM@" + String(partyId) + "/WITH@" + String(guestUid) + "/message"
  );
  const roomsRef = child(
    dbRef,
    "ROOM@" + String(partyId) + "/WITH@" + String(guestUid)
  );

  if (guestUid === enterUid) {
    console.log("guestUid === enterUid", guestUid, enterUid);
    update(chatRoomsRef, {
      Guest_uid: enterUid,
      Guest_lastTime: serverTimestamp(),
    });
  } else {
    console.log("guestUid !== enterUid", guestUid, enterUid);

    update(chatRoomsRef, {
      Host_uid: enterUid,
      Host_lastTime: serverTimestamp(),
    });
  }

  // 읽음 처리
  // 입장인이 마지막 보낸 메세지의 수신자라면 읽음 처리를 한다.

  let toUserEnter = false;

  await get(roomsRef).then((snapshot) => {
    console.log("❤", Object.keys(snapshot.val()));

    if (Object.keys(snapshot.val())?.includes("message")) {
      get(chatRoomsMessageRef).then((snapshot) => {
        if (snapshot.val().to === enterUid) {
          toUserEnter = true;
        }

        if (toUserEnter) {
          update(chatRoomsMessageRef, {
            isRead: true,
          });
        }
      });
    }
  });
};

// 방에서 나간다.
export const ExitRoom = (
  partyId: number,
  guestUid: number,
  exitUid: number
) => {
  console.log(partyId, guestUid, exitUid);
  const dbRef = ref(
    database,
    isBeta ? "Beta/PartyChatRooms" : "Live/PartyChatRooms"
  );
  const chatRoomsRef = child(
    dbRef,
    "ROOM@" + String(partyId) + "/WITH@" + String(guestUid) + "/loggedIn"
  );

  if (guestUid === exitUid) {
    update(chatRoomsRef, {
      Guest_uid: 0,
    });
  } else {
    update(chatRoomsRef, {
      Host_uid: 0,
    });
  }
};

// 해당 유저가 현재 채팅방에 들어와 있는지.
export const checkNowOnRoom = async (
  partyId: number,
  guestUid: number,
  isHostChk: boolean
) => {
  let isTargetOnRoom = false;

  //  5분이 지나면 만료 시킨다.
  const time = new Date().getTime();

  const dbRef = ref(
    database,
    isBeta ? "Beta/PartyChatRooms" : "Live/PartyChatRooms"
  );
  const chatRoomsRef = child(
    dbRef,
    "ROOM@" + String(partyId) + "/WITH@" + String(guestUid) + "/loggedIn"
  );

  try {
    if (isHostChk) {
      return await get(chatRoomsRef)
        .then((snapshot) => {
          console.log(snapshot);
          if (
            snapshot.val().Host_uid > 0 &&
            (time - snapshot.val()?.Host_lastTime) / 60000 < 5
          ) {
            isTargetOnRoom = true;
          } else {
            isTargetOnRoom = false;
          }

          console.log(isTargetOnRoom);
          return isTargetOnRoom;
        })
        .catch((error) => {
          console.error(error);
        });
    } else {
      return await get(chatRoomsRef)
        .then((snapshot) => {
          console.log(snapshot.val());
          if (
            snapshot.val().Guest_uid > 0 &&
            (time - snapshot.val().Guest_lastTime) / 60000 < 5
          ) {
            isTargetOnRoom = true;
          } else {
            isTargetOnRoom = false;
          }

          console.log(isTargetOnRoom);
          return isTargetOnRoom;
        })
        .catch((error) => {
          console.log(error);
        });
    }
  } catch (error) {
    console.log(error);
  }
};

// 신고하기
export const reportMsg = async (
  user: { loginSuccess: { uid: number } },
  msgList: string[],
  reason: string,
  reasonid: number,
  time: any,
  partyId: number,
  toUid: number,
  hostUid: number
) => {
  const uid = user?.loginSuccess?.uid ?? 0;

  const dbRef = ref(database, isBeta ? "Beta/UserReport" : "Live/UserReport");

  try {
    return await push(dbRef, {
      msgList,
      reason,
      reasonid,
      time: serverTimestamp(),
      partyid: Number(partyId),
      uid,
      target: toUid,
      owner: hostUid,
    });
  } catch (error) {
    return error;
  }
};

// 최근 메세지 저장하기 (LatestMessages)
export const saveLatestMsg = async (
  from_uid: number,
  to_uid: number,
  msg: string,
  partyid: number,
  host_uid: number
) => {
  const dbRef = ref(
    database,
    isBeta ? "Beta/LatestMessages" : "Live/LatestMessages"
  );

  try {
    return await push(dbRef, {
      sender: from_uid,
      receiver: to_uid,
      msg: msg,
      time: serverTimestamp(),
      partyid: Number(partyid),
      from_host: from_uid === host_uid ? true : false,
    });
  } catch (error) {
    return error;
  }
};

// 채팅 암호화
export const encryptChat = (msg: string) => {
  const eventkey = "$specialchaat$1@";
  const eventiv = "5678901234123456";
  const iv = CryptoJS.enc.Utf8.parse(eventiv);

  const encrypted = CryptoJS.AES.encrypt(JSON.stringify(msg), eventkey, {
    iv,
  });

  let encryptedChat = encrypted.toString();

  return encryptedChat;
};

// 채팅 복호화
export const decryptChat = (encryptedMsg: string) => {
  const eventkey = "$specialchaat$1@";
  const eventiv = "5678901234123456";
  const iv = CryptoJS.enc.Utf8.parse(eventiv);

  const decrypted = CryptoJS.AES.decrypt(encryptedMsg, eventkey, {
    iv,
  });

  let decryptedChat =
    decrypted?.sigBytes > 0
      ? JSON.parse(decrypted?.toString(CryptoJS.enc.Utf8) ?? "{}")
      : ""; // 복호화된 채팅

  return decryptedChat;
};

export const checkFword = (originMsg: string) => {
  let replaced_str = originMsg;
  for (let i = 0; i < fword.length; i++) {
    replaced_str = replaced_str?.replace(fword[i].INDEX, "***");
  }

  const val = {
    hasFword: originMsg !== replaced_str ? true : false,
    replaced: replaced_str,
    origin: originMsg,
  };

  return val;
};

export const unixTimeToTimeForRooms = (time: string) => {
  var date = new Date(time);

  let today = moment().format("MM월 DD일");

  var year = date.getFullYear();
  var month = "0" + (date.getMonth() + 1);
  var day = "0" + date.getDate();
  var hour = "0" + date.getHours();
  var minute = "0" + date.getMinutes();

  if (today === month.substr(-2) + "월 " + day.substr(-2) + "일") {
    return hour.substr(-2) + ":" + minute.substr(-2);
  } else {
    return month.substr(-2) + "월 " + day.substr(-2) + "일";
  }
};
